import React, {Component} from 'react';
import '../../../../members/client-member-list.css';
import PropTypes from 'prop-types';
import {handleElementSelect, handleSelectAll} from '../../../../../../../../utils/ComponentUtilFunctions';
import {filterElements, filterInputStyle} from '../../../../../../../../utils/General';
import Translate from '../../../../../../../../components/Translate';
import TranslateProperty from "../../../../../../../../components/TranslateProperty";
import TableAction from "../../../../../../../../components-new/table/TableAction";
import PlusIcon from "../../../../../../../../assets/icons/PlusIcon";
import Colors from "../../../../../../../../utils/Colors";
import SilverButton from "../../../../../../../../components-new/buttons/SilverButton";
import ContactAvatar from "../../../../../../../../components-new/general/ContactAvatar";
import Checkbox from "../../../../../../../../components-new/form/Checkbox";
import SearchInput from "../../../../../../../../components-new/form/SearchInput";
import TableScroll from "../../../../../../../../components-new/table/TableScroll";

const searchBackgroundColorStyle = {
    backgroundColor: 'transient',
};

class NotConnectedMembers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nameFilter: '',
            selectedIds: [],
        };
        this.handleSelectAll = handleSelectAll(this.getFilteredMembers, this);
        this.handleMemberSelect = handleElementSelect.bind(this);
    }

    getFilteredMembers = () => {
        const {notConnectedMembers} = this.props;
        const {selectedIds} = this.state;

        return filterElements(notConnectedMembers, '', member => selectedIds.includes(member.id));
    };

    filterByName = () => {
        const {nameFilter} = this.state;

        return this.getFilteredMembers().filter(op => {
            return (op.firstName + " " + op.lastName).toLowerCase().includes(nameFilter.toLowerCase())
        });
    }


    handleNameFilterChange = (text) => {
        this.setState({
            nameFilter: text,
        });
    };

    addSelectedMembers = () => {
        const {notConnectedMembers} = this.props;
        const {selectedIds} = this.state;
        const selectedMembers = notConnectedMembers.filter(member => selectedIds.includes(member.id));
        this.addMembersToClient(selectedMembers);
    };

    addMembersToClient = (members) => {
        const {addMembersToClient, client} = this.props;
        addMembersToClient(members, client).then(() => {
            const {selectedIds} = this.state;
            this.setState({
                selectedIds: selectedIds.filter(id => members.findIndex(member => member.id === id) === -1),
            });
        });
    };

    render() {
        const {
            nameFilter, selectedIds,
        } = this.state;

        const filteredMembers = this.filterByName();

        return (
            <div style={{display: 'flex', flexDirection: 'column', padding: '20px', minHeight: '50vh', height: '100%'}}>
                <div style={{marginBottom: '20px', display: 'flex', gap: '20px', justifyContent: 'center'}}>
                    <SearchInput
                        containerStyle={{flexGrow: 1, maxWidth: '480px'}}
                        value={nameFilter}
                        onChange={(e) => this.handleNameFilterChange(e.target.value)}
                        placeholder={'searchByOperator'}
                    />
                </div>
                <TableScroll style={{minHeight: 0}} stickyActions>
                    <table className="custom-table client-members-table" style={{minWidth: '600px'}}>
                        <thead>
                        <tr className="table-head">
                            <th className="client-members-table__checkbox-column">
                                <Checkbox
                                    checked={filteredMembers.length === selectedIds.length && filteredMembers.length}
                                    handleChange={this.handleSelectAll}
                                />
                            </th>

                            <th>
                                <div style={searchBackgroundColorStyle}>
                                    <Translate text="operator"/>
                                </div>
                            </th>
                            <th style={{textAlign: "center"}}>
                                <SilverButton
                                    width="auto"
                                    height="32px"
                                    styles={{
                                        visibility: selectedIds.length > 0 ? 'visible' : 'hidden',
                                        fontSize: '11px',
                                        margin: '0 auto'
                                    }}
                                    onClick={this.addSelectedMembers}
                                >
                                    <Translate text="add"/>{` (${selectedIds.length})`}
                                </SilverButton>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {filteredMembers.length === 0 && (
                            <tr className="table-no-result">
                                <td className="client-members-table__empty" colSpan={3}>
                                    <Translate text="noResultsFound"/>
                                </td>
                            </tr>
                        )}
                        {filteredMembers.map(member => (
                            <tr key={member.id} className="body-row">
                                <td className="checkbox-header client-members-table__checkbox-column">
                                    <Checkbox
                                        checked={selectedIds.includes(member.id)}
                                        handleChange={this.handleMemberSelect(member.id)}
                                    />
                                </td>

                                <td className="user-info">
                                    <div style={{display: 'flex', alignItems: 'center', gap: '11px'}}>
                                        <ContactAvatar contact={member}/>
                                        <div style={{display: 'flex', flexDirection: 'column'}}>
                                            <span
                                                className="name-text">{`${member.firstName} ${member.lastName}`}</span>
                                            <span className="email-text">{member.email}</span>
                                        </div>
                                    </div>
                                </td>

                                <td className="add-cell">
                                    {/* a button, not a cell you happen to be able
                                        to click: the plus alone said nothing */}
                                    <TableAction
                                        tooltip={'connect'}
                                        onClick={() => this.addMembersToClient([member])}
                                        icon={<PlusIcon width={18} height={18} stroke="currentColor"/>}
                                    />
                                </td>
                            </tr>
                        ))
                        }
                        </tbody>
                    </table>
                </TableScroll>
            </div>
        );
    }
}

NotConnectedMembers.propTypes = {
    notConnectedMembers: PropTypes.array.isRequired,
    client: PropTypes.object.isRequired,
    addMembersToClient: PropTypes.func.isRequired,
};
export default NotConnectedMembers;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/operators/components/NotConnectedMembers.jsx